import { render, staticRenderFns } from "./PmLayout.vue?vue&type=template&id=2405b7c2&scoped=true"
import script from "./PmLayout.vue?vue&type=script&lang=js"
export * from "./PmLayout.vue?vue&type=script&lang=js"
import style0 from "./PmLayout.vue?vue&type=style&index=0&id=2405b7c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2405b7c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2405b7c2')) {
      api.createRecord('2405b7c2', component.options)
    } else {
      api.reload('2405b7c2', component.options)
    }
    module.hot.accept("./PmLayout.vue?vue&type=template&id=2405b7c2&scoped=true", function () {
      api.rerender('2405b7c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/PmLayout.vue"
export default component.exports